// #D8E3E7
// #DDFFBC
// #91C788
// #52734D
// #191919

import { makeStyles } from '@material-ui/core/styles';

export const useMainPaperStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100vW',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: '100vH',
    },
    homepage: {
      minWidth: '98%',
      marginTop: '0.5em',
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        marginTop: '1em',
        display: 'block',
      },
    },
    postsPanel: {
      minWidth: '40vW',
      flexGrow: 1,
    },
  }),
  { index: 1 }
);

// const useStyles = makeStyles((theme) => ({

//   card: {
//     border: 0,
//     marginTop: 10,
//     boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
//     borderRadius: 15,
//     marginBottom: 25,
//     maxWidth: 900,
//     height: 620,
//   },
//   media: {
//     height: 450,
// },
// }));

export const useNavStyles = makeStyles(
  (theme) => ({
  //   muiInputBase:{
  //    outline:'none',
  // },
    muiInputFormControl:{
      border: 'none' ,      
    },
    elevation:{
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      marginBottom: 5
    },
    leftPortion: {
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        marginLeft: '1em',
      },
    },
    logoWrapper: {
      marginRight: theme.spacing(10),
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
      },
      // svg:{
      //   height: '100px',
      // }
    },
    logo: {
      fontFamily:'Lexend Deca',
      textTransform: 'none',
      fontSize: '1.3em',
      padding: '0.1em',
      marginRight: '0.3em',
    },
    user: {
      marginRight: 10,
    },
    titleButton: {
      textTransform: 'none',
      fontSize: 20,
      marginRight: 12,
    },
    navButtons: {
      '&:hover': {
        backgroundColor: '#52734D',
      },
    },
    search: {
      flexGrow: 0.75,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 10 ,
      borderRadius: 15,
      padding: '0.5em',
      [theme.breakpoints.down('sm')]: {
        flexGrow: 1,
        padding: '0 0.5em',
      },
    },
    searchBtn: {
      border: 'none',
      padding: 0,
      background: 'none',
      padding: '0.2em',
    },
  }),
  { index: 1 }
);

export const useAuthStyles = (authType) =>
  makeStyles(
    (theme) => ({
      authWrapper: {
        display: 'flex',
        flexDirection: authType === 'login' ? 'row' : 'row-reverse',
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          marginTop: 10,
        },
      },
      form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        [theme.breakpoints.down('xs')]: {
          padding: '0 0 0 0',
        },
      },
      formTitle: {
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
          fontSize: '1.5em',
        },
      },
      switchText: {
        textAlign: 'center',
        marginBottom: '1.2em',
        [theme.breakpoints.down('xs')]: {
          marginBottom: 0,
          fontSize: '1em',
        },
      },
      submitButton: {
        marginTop: '1.8em',
      },
      input: {
        display: 'flex',
        alignItems: 'flex-end',
      },
      inputIcon: {
        marginRight: 8,
      },
      sidePanel: {
        padding: 20,
        margin: 'auto 0',
      },
      divider: {
        marginLeft: 40,
        marginRight: 40,
      },
    }),
    { index: 1 }
  );

export const useDialogStyles = makeStyles(
  (theme) => ({
    dialogWrapper: {
      padding: 0,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      borderRadius: 15,
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
    createPostWrapper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      display: 'flex',
      width: 'auto',
      borderRadius: 15,
      marginBottom: 10,
      padding: 6,
      alignItems: 'center',
    },
    iconeCol:{
      color: theme.palette.type === 'light' ? '#91C788' : '#DDFFBC',

    },
    createBtn: {
      border: 'none' ,
      borderRadius: 15,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      marginLeft: 8,
      textTransform: 'none',
      justifyContent: 'flex-start',
    },
    fab: {
      position: 'abslote',
      // bottom: 1,
      right: -165,
      // top: -0 ,
      zIndex: 1000,
    },
    iconGroup: {
      display: 'flex',
    },
    dialogTitle: {
      fontSize: '1.2em',
    },
    createSubBtn: {
      marginTop: '1em',
    },
    defaultAvatar: {
      backgroundColor: theme.palette.secondary.main,
    },
  }),
  { index: 1 }
);

export const useAlertStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
      marginTop: '0.8em',
      marginBottom: '0.8em',
    },
  }),
  { index: 1 }
);

export const usePostListStyles = makeStyles(
  (theme) => ({
    root: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      borderRadius: 15,
      border: 'none' ,
      width: '100%',
      marginBottom: '1em',
    },
    loadBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    loadBtn: {
      marginTop: '0.8em',
      width: '50%',
    },
    noSubscribedPosts: {
      textAlign: 'center',
      marginTop: '5em',
    },
    loadSpinner: {
      textAlign: 'center',
      marginTop: '12em',
      marginBottom: '6em',
    },
  }),
  { index: 1 }
);


// export const useStyles = makeStyles(
//   (theme) => ({
//   card: {
//     margin: "auto",
//     border: 0,
//     marginTop: 10,
//     boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
//     transition: 3,
//     borderRadius: 15,
//     marginBottom: 25,
//     maxWidth: 900,
//     height: 620,
//   },
//   media: {
//     height: 450,
// },
// }));

export const useCardStyles = makeStyles(
  (theme) => ({
    card: {
      margin: "auto",
      border: 0,
      marginTop: 10,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      borderRadius: 15,
      marginBottom: 25,
      maxWidth: 900,
      height: 620,
    },
    media: {
      
      height: 200,
  },
  CardContentStyle: {
    marginTop: 150,

  },
    root: {
      display: 'flex',
      width: 'auto',
      borderRadius: 0,
    },
    votesWrapper: {
      display: 'flex',
      // flexDirection: 'column',
      position: 'absolute',
      marginTop: 100,
      marginLeft:750,
      width: 30,
      alignItems: 'center',
      // backgroundColor: theme.palette.type === 'light' ? '#D8E3E7' : '#191919',
      // backgroundColor: theme.palette.type === 'light' ? '#f7f5f3' : '#2f271f',
      [theme.breakpoints.down('xs')]: {
        marginTop: 120,
        marginLeft:200,

      },
    },
    thumbnailWrapper: {
      alignSelf: 'center',
      // marginLeft: 5,
    },
    thumbnail: {
      // fontSize: '2em',
      width: 900,
      height: 450,
      textAlign: 'center',
      backgroundColor: theme.palette.type === 'light' ? '#D8E3E7' : '#191919',
      // borderRadius: 8,
      [theme.breakpoints.down('xs')]: {
        width: 380,
        height: 450,
      },
    },
    thumbnailIcon: {
      marginTop: 100,
      fontSize:250,
    },
    postInfoWrapper: {
      padding: 10,
      paddingBottom: 0,
    },
    userAndDate: {
      marginLeft: 10,
    },
    commentsBtn: {
      position: 'absolute',

      marginTop: 110,
      textTransform: 'none',
      color: theme.palette.type === 'light' ? '#787878' : '#dadada',
      [theme.breakpoints.down('xs')]: {
        marginTop: 125,
      },
    },
    title: {
      position: 'absolute',
      marginTop: 90,
      [theme.breakpoints.down('xs')]: {
        marginTop: 80,
      },
    },
    bottomBtns: {
      display: 'flex',
    },
  }),
  { index: 1 }
);

export const usePostFormStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
      flexGrow: 1,
      [theme.breakpoints.down('xs')]: {
        padding: '0 0 0 0',
      },
    },
    formTitle: {
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.5em',
      },
    },
    submitButton: {
      marginTop: '1.8em',
    },
    input: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: '0.7em',
    },
    inputIcon: {
      marginRight: 8,
    },
    inputIconText: {
      padding: 2,
      paddingBottom: 0,
      marginRight: 9,
      fontWeight: 700,
      wordBreak: 'keep-all',
    },
    typeBtnGroup: {
      marginBottom: 5,
    },
    imageInput: {
      marginTop: '1em',
    },
    imageBtnsWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    imagePreview: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '0.7em',
    },
    clearSelectionBtn: {
      padding: '0.25em',
    },
    selectBtn: {
      textTransform: 'capitalize',
    },
    textInput: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: '1.5em',
    },
  }),
  { index: 1 }
);

export const usePostCommentsStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      borderRadius: 15,
      margin: '0.5em',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '90vH',
    },
    topPortion: {
      display: 'flex',
    },
    votesWrapper: {
      borderTopLeftRadius:15,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      display: 'flex',
      flexDirection: 'column',
      width: 50,
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: theme.palette.type === 'light' ? '#D8E3E7' : '#191919',
      // backgroundColor: theme.palette.type === 'light' ? '#f7f5f3' : '#2f271f',
      [theme.breakpoints.down('xs')]: {
        width: 35,
      },
    },
    postDetails: {

      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: '0.5em',
      [theme.breakpoints.down('xs')]: {
        padding: '0em',
      },
    },
    title: {
      fontWeight: 500,
      marginBottom: '0.7em',
    },
    imagePost: {
      textAlign: 'center',
    },
    image: {
      width: '50%',
      [theme.breakpoints.down('xs')]: {
        width: '40%',
      },
      border: '1px solid #e9e3d8',
      borderRadius: 8,
    },
    bottomBar: {
      display: 'flex',
      marginTop: '0.8em',
      [theme.breakpoints.down('xs')]: {
        fontSize: '0.9em',
      },
    },
    bottomButton: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1em',
    },
    commentIcon: {
      marginRight: 10,
    },
    commentsContainer: {
      marginLeft: '0.7em',
      [theme.breakpoints.down('xs')]: {
        marginLeft: '0.3em',
      },
    },
    divider: {
      
      marginBottom: '2em',
    },
    wholeComment: {
      marginBottom: '1em',
      marginRight:10,
      borderRadius:15,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
    },
    commentWrapper: {
      borderRadius:15,
      padding:10,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      display: 'flex',
    },
    commentVotesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: 30,
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    commentDetails: {
      display: 'flex',
      flexDirection: 'column',
      padding: '1em',
      paddingTop: '0.7em',
      width: '100%',
    },
    replyWrapper: {
      marginBottom: '0.2em',
      display: 'flex',
      marginLeft: '2em',
    },
    noCommentsBanner: {
      textAlign: 'center',
      marginTop: '5em',
    },
    loadSpinner: {
      textAlign: 'center',
      marginTop: '12em',
    },
  }),
  { index: 1 }
);

export const useCommentInputStyles = makeStyles(
  (theme) => ({
    wrapper: {
      padding:5,
      borderRadius:15,
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      marginTop: '0.5em',
      marginBottom: '2.5em',
      margin: '0.4em',
      [theme.breakpoints.down('xs')]: {
        padding:-50,

      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    commentBtn: {
      alignSelf: 'flex-end',
      marginTop: '1em',
      marginBottom: '0.5em',
      marginRight: '0.5em',
    },
  }),
  { index: 1 }
);

export const useCommentAndBtnsStyles = makeStyles(
  (theme) => ({
    inputDiv: {
      display: 'flex',
      flexDirection: 'column',
    },
    submitBtns: {
      alignSelf: 'flex-end',
      marginTop: '0.1em',
    },
    btnStyle: {
      textTransform: 'none',
    },
    btnBar: {
      display: 'flex',
    },
    cancelBtn: {
      marginRight: '0.2em',
      marginTop: '0.1em',
    },
  }),
  { index: 1 }
);

export const useUserPageStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      border: 'none',
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      borderRadius: 15,
      margin: '1em',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '90vH',
      paddingBottom: '1em',
    },
    userInfoWrapper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      width: 'auto',
      borderRadius: 15,
      margin: '0.5em',
      padding: '0.8em',
      display: 'flex',
      justifyContent: 'space-around',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    itemWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    avatarWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    rightWrapper: {
      flexGrow: 0.3,
      display: 'flex',
      justifyContent: 'space-between',
    },
    twoItemsDiv: {
      textAlign: 'center',
    },
    avatar: {
      width: '5em',
      height: '5em',
      [theme.breakpoints.down('xs')]: {
        width: '3em',
        height: '3em',
      },
    },
    cakeDay: {
      display: 'flex',
      alignItems: 'center',
    },
    postsPaper: {
      margin: '0.5em',
    },
    loadBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    loadBtn: {
      width: '50%',
    },
    noPosts: {
      textAlign: 'center',
      marginTop: '5em',
    },
    loadSpinner: {
      textAlign: 'center',
      marginTop: '12em',
    },
  }),
  { index: 1 }
);



export const useUserPostCardStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      display: 'flex',
      marginBottom: '1em',
      textDecoration: 'none',
      '&:hover': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
    votesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: 50,
      alignItems: 'center',
      justifyContent: 'flex-start',
      [theme.breakpoints.down('xs')]: {
        width: 35,
      },
    },
    title: {
      fontWeight: 500,
      marginBottom: '0.7em',
    },
    imagePost: {
      textAlign: 'center',
    },
    image: {
      width: '30%',
      [theme.breakpoints.down('xs')]: {
        width: '40%',
      },
      border: '1px solid #e9e3d8',
      borderRadius: 8,
    },
    postInfo: {




      paddingTop: '0.5em',
      padding: '0.2em',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    commentsBtn: {
      marginTop: '0.5em',
    },
  }),
  { index: 1 }
);

export const useSubPageStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      marginTop: '0.5em',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '90vH',
      paddingBottom: '1em',
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      width: 'auto',
      borderRadius: 15,
    },
    subInfoWrapper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
      width: 'auto',
      borderRadius: 15,
      margin: '0.5em',
      padding: '0.8em',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    iconText: {
      display: 'flex',
      alignItems: 'flex-end',
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    secondPanel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        marginTop: '1em',
      },
    },
    joinBtn: {
      marginBottom: '0.4em',
    },
    description: {
      display: 'flex',
      alignItems: 'flex-end',
      flexWrap: 'wrap',
      margin: '0.3em 0',
      maxWidth: 300,
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
      },
    },
    inputDiv: {
      display: 'flex',
      flexDirection: 'column',
    },
    submitBtns: {
      alignSelf: 'flex-end',
      marginTop: '0.1em',
    },
    firstPanel: {
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
    testt:{
      maxWidth:10
    },
    testtt:{
      margin: '100m',

    },
    loadBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    loadBtn: {
      marginTop: '0.8em',
      width: '50%',
    },
    noPosts: {
      textAlign: 'center',
      marginTop: '5em',
    },
    loadSpinner: {
      textAlign: 'center',
      marginTop: '12em',
    },
  }),
  { index: 1 }
);

export const useSortTabStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      borderRadius: 15,
      border: 'none' ,
      // margin: '1em',
      marginTop: '1em',
      marginBottom: '2em',
      [theme.breakpoints.down('xs')]: {
        marginBottom: '0em',
      },
    },
  }),
  { index: 1 }
);

export const useSubPanelStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      minWidth: '25%',
      borderRadius: 15,
      marginLeft: '0.5em',
      padding: '0.5em',
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      border: 'none' ,
    },
    iconPaper:{
      // position: 'absolute',
      // marginLeft: '-0.5em',

    },
    panlPaper:{
      // width:auto,
      // backgroundImage: `url("https://i.ibb.co/BybVrnY/crop.png")`, 
      backgroundImage: "url(https://i.ibb.co/BybVrnY/crop.png)" ,
      // backgroundRepeat: 'no-repeat',

      backgroundSize: 'cover',
       height: 250,
       borderTopRightRadius:15,

    },
    imgPaper:{

      // `url("https://via.placeholder.com/500")` 

      // position: 'absolute',
      // backgroundRepeat: 'no-repeat',
      // backgroundSize: 'cover',
      // borderTopLeftRadius: 15 ,
      // borderTopRightRadius: 15 ,
      // height: 240,
      // maxWidth: 900,
      
      // marginTop: 9,
      // backgroundImage: "url(data:image/jpeg;base64,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)",

      // width:200,
      margin: 'auto',
      padding: 'auto',
      display:'flex',
      alignItems: 'center',
      justifyContent:'center',

        // display:'flex',
        // justifyContent:'center',
        // alignContent:'center',
        // marginLeft:65,

      // padding: 83.5,
      // Width: 'auto',

    },
    EmtyPaper: {
      padding: '4em',

    },
    listPaper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      padding: '0.4em',
      borderRadius: 15,
      border: 'none' ,
    },
    title: {
      textAlign: 'center',
      marginBottom: '1em',
    },
    listItem: {
      fontSize: '1.1em',
    },
    listWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '1em',
    },
  }),
  { index: 1 }
);

export const useSubredditFormStyles = makeStyles(
  (theme) => ({
    formWrapper: {
      [theme.breakpoints.down('xs')]: {
        marginTop: 10,
      },
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
      [theme.breakpoints.down('xs')]: {
        padding: '0 0 0 0',
      },
    },
    formTitle: {
      textAlign: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.5em',
      },
    },
    submitButton: {
      marginTop: '1.8em',
      marginBottom: '0.5em',
    },
    input: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    inputIcon: {
      marginRight: 8,
    },
    inputIconText: {
      padding: 2,
      paddingBottom: 0,
      marginRight: 9,
      fontWeight: 700,
      wordBreak: 'keep-all',
    },
    descInput: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: '1.5em',
    },
  }),
  { index: 1 }
);

export const useUserMenuStyles = makeStyles(
  (theme) => ({
    userBtn: {
      textTransform: 'none',
      display: 'flex',
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: '0.1em',
      backgroundColor: theme.palette.secondary.main,
      [theme.breakpoints.up('xs')]: {
        marginRight: '0.5em',
      },
    },
    userBtnMob: {},
    navItems: {
      display: 'flex',
      alignItems: 'center',
    },
    karmaWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
  { index: 1 }
);

export const useAvatarFormStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: '1em',
    },
    title: {
      textAlign: 'center',
    },
    selectBtn: {
      textTransform: 'none',
    },
    clearSelectionBtn: {
      padding: '0.25em',
    },
    imageBtnsWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: '1em',
    },
    imagePreview: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '0.7em',
    },
    submitButton: {
      marginTop: '1.4em',
    },
    currentAvatar: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '0.5em',
    },
    currentAvatarText: {
      marginRight: '0.5em',
    },
  }),
  { index: 1 }
);

export const useSearchPageStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      marginTop: '0.5em',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 0,
      minHeight: '90vH',
      paddingBottom: '1em',
    },
    infoPaper: {
      padding: '0.8em',
      display: 'flex',
      alignItems: 'flex-start',
    },
    noResults: {

      textAlign: 'center',
      display: 'flex',
      justifyContent:'center',
      justifyItems:'center',
      width: 'auto',
      flexDirection: 'column',
      marginTop: '1em',
    },
    sorryIcon: {
      marginRight: '7px',
      fontSize: '4em',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    loadBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    loadBtn: {
      marginTop: '0.8em',
      width: '50%',
    },
  }),
  { index: 1 }
);

export const useSortCommentsStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      marginRight: 10,
      display: 'flex',
      alignItems: 'center',
    },
  }),
  { index: 1 }
);

export const useNotFoundPageStyles = makeStyles(
  (theme) => ({
    mainPaper: {
      boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
      transition: 3,
      padding: '1em',
      borderRadius: 15,
      border: 'none' ,



      marginTop: '0.5em',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '90vH',
      textAlign: 'center',
    },
    textWrapper: {
      marginTop: '5%',
    },
    icon: {
      fontSize: '8em',
      marginBottom: '0.3em',
    },
  }),
  { index: 1 }
);
